var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrimaryChecked = function SvgPrimaryChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5DD927",
    d: "M10 1.875a8.125 8.125 0 1 1 0 16.25 8.125 8.125 0 0 1 0-16.25M10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20m4.414-11.836A.937.937 0 0 0 13.09 6.84l-4.336 4.336L6.918 9.34a.937.937 0 0 0-1.324 1.324l2.5 2.5a.934.934 0 0 0 1.324 0z"
  })));
};
export default SvgPrimaryChecked;